/**
 * Represents a community label component.
 */
export default class CommunityLabel {
  /**
   * Creates an instance of CommunityLabel.
   */
  constructor() {
    this.id = 'summaryCardLabel';
  }

  /**
   * Sets the information for the label.
   *
   * @param {Object} summaryCard - The summary card object.
   */
  setInformation(summaryCard) {
    this.isFeaturedListing = summaryCard.IsFeaturedListing;
    this.CommunityType = summaryCard.CommunityType;
  }

  /**
   * Gets the HTML element with the specified ID.
   * @returns {HTMLElement} The HTML anchor element.
   */
  getElement() {
    return document.getElementById(this.id);
  }

  getClassVariation() {
    if (this.isFeaturedListing) {
      return 'nhs-c-listing-status--spotlight';
    }

    return '';
  }

  /**
   * Retrieves the text for the community label based on the community type and featured listing status.
   * @returns {string} The text for the community label.
   */
  getText() {
    if (this.isFeaturedListing) {
      return 'Spotlight';
    }

    return '';
  }

  /**
   * Returns the HTML representation of the summary card.
   * @returns {string} The HTML string representing the summary card.
   */
  getHtml() {
    const text = this.getText();

    if (!text) {
      return '';
    }

    return `<span class="nhs-c-listing-status ${this.getClassVariation()}">${this.getText()}</span>`;
  }
}
